/* eslint-disable no-console */
// Keeps the swatch cart count badge on the header Cart icon in sync with
// localStorage `graberSwatchCart` (see swatch-cart-favorites.js / Checkout).
// Re-renders on `graber:cart-updated` (same tab) and `storage` (other tabs).

import { CART_STORAGE_KEY, CART_UPDATED_EVENT } from './swatch-cart-favorites';

export default () => {
  const getCartCount = () => {
    try {
      const raw = window.localStorage.getItem(CART_STORAGE_KEY);
      if (!raw) {
        return 0;
      }

      const parsed = JSON.parse(raw);
      return (parsed && Array.isArray(parsed.items)) ? parsed.items.length : 0;
    } catch (e) {
      return 0;
    }
  };

  const render = (ct) => {
    const navItemSelectors = '.icon-item-cart .icon-nav-item, .icon-item-my-cart .icon-nav-item';
    const indicatorClass = 'swatch-count items-added-to-swatches';
    const navItemDivs = document.querySelectorAll(navItemSelectors);
    [].forEach.call(navItemDivs, (navItem) => {
      const indicatorDiv = navItem.querySelector('.swatch-count');
      if (ct === 0 && indicatorDiv) {
        indicatorDiv.remove();
      } else if (ct > 0 && indicatorDiv) {
        indicatorDiv.textContent = ct;
      } else if (ct > 0 && indicatorDiv === null) {
        const span = document.createElement('span');
        span.className = indicatorClass;
        span.textContent = ct;
        navItem.appendChild(span);
      }
    });
  };

  const update = () => {
    // Only logged-in users see the cart count badge; when not authenticated,
    // force a count of 0 so any existing badge is removed and none is added.
    const count = window.isAuthenticated ? getCartCount() : 0;
    render(count);
  };

  window.addEventListener(CART_UPDATED_EVENT, update);
  window.addEventListener('storage', (event) => {
    if (!event || event.key === null || event.key === CART_STORAGE_KEY) {
      update();
    }
  });

  update();
};
/* eslint-enable no-console */
